export default "__VITE_ASSET__B2EG09i2__"